<div class="wrapper">
    <section class="flex justify-between items-center bg-white border-2 border-b-indigo-800">
        <h2 class="top-div-header" matDialogTitle>
            Add new PPA
        </h2>
        <button type="button" mat-icon-button (click)="close()" title="Close dialog">
            <mat-icon fontIcon="close" aria-label="close icon"></mat-icon>
        </button>
    </section>

    <section form-section>
        <form class="flex flex-col gap-4 md:gap-2" [formGroup]="newPlaceForm" (ngSubmit)="postNewPlace()">

            <mat-form-field>
                <mat-label>PPA name</mat-label>
                <input matInput 
                
                placeholder="St. Mary's School" formControlName="name" required
                [matAutocomplete]="autoPpaNames" 
                />
                <!-- @todo: if they select an option - we need to disable it. So they enter a new value that isn't existing. -->
                <mat-autocomplete #autoPpaNames="matAutocomplete"
                [displayWith]="displayPpaName"
                (optionSelected)="ppaSelected($event)"
                >
                  <mat-option *ngFor="let option of filteredLgaPPAs | async" [value]="option?.name" [id]="option?.id">
                    {{option?.name}}
                  </mat-option>
                </mat-autocomplete>
                <mat-hint>Exactly as seen on your letter of posting</mat-hint>
                
                <mat-error *ngIf="newPlaceForm.get(['name'])?.hasError('required')">
                  Name is <strong>required</strong>
              </mat-error>
              </mat-form-field>

              <mat-form-field>
                <!-- todo: "Type of Institution" or "Type of PPA"??  -->
                <mat-label>Type of Institution</mat-label>
                <input matInput placeholder="Gov. Institution" formControlName="category" 
                required [matAutocomplete]="autoTypeOfInstitution" />
                <mat-error *ngIf="newPlaceForm.get(['category'])?.hasError('required')">
                  Type of Institution is <strong>required</strong>
              </mat-error>
              <mat-autocomplete autoActiveFirstOption #autoTypeOfInstitution="matAutocomplete">
                <mat-option *ngFor="let option of filteredTypeOfInstitutionOptions | async" [value]="option">
                  {{option}}
                </mat-option>
                <!-- LATER: this other specify kinda works right now... can the UX be improved? -->
                <mat-option value="">
                    Others (Specify)
                  </mat-option>
              </mat-autocomplete>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Address</mat-label>
                <input matInput placeholder="No. 26, B lane, Atero Street, Abuja" formControlName="address" required
                [matAutocomplete]="autoPpaAddress"
                />

                <mat-autocomplete autoActiveFirstOption #autoPpaAddress="matAutocomplete">
                  <mat-option *ngFor="let option of filteredPpaAddressesOptions | async" [value]="option">
                    {{option}}
                  </mat-option>
                  <!-- <mat-option value="">
                      Others (Specify)
                    </mat-option> -->
                </mat-autocomplete>

                <mat-hint>Exactly as seen on your letter of posting</mat-hint>
                <mat-error *ngIf="newPlaceForm.get(['address'])?.hasError('required')">
                  Address is <strong>required</strong>. Please enter exactly as seen on your letter of posting.
              </mat-error>
              </mat-form-field>

              <mat-form-field>
                <!-- TODO: Should be pre-filled with their state of registration & LGA -->
                <mat-label>State</mat-label>
                <mat-select formControlName="state_id">
                  <mat-option *ngFor="let state of ng_states" [value]="state?.id">
                    {{state?.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="newPlaceForm.get(['state_id'])?.hasError('required')">
                  State is <strong>required</strong>
              </mat-error>
              </mat-form-field>

              <mat-form-field>
                <!-- TODO: Should have a loader -->
                <mat-label>LGA</mat-label>
                <mat-select formControlName="state_lga_id">
                  <mat-option *ngFor="let lga of ng_states_lgas" [value]="lga?.id">
                    {{lga?.name}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="!newPlaceForm.get(['state_id'])?.value">Select a State to see options</mat-hint>
                <mat-error *ngIf="newPlaceForm.get(['state_lga_id'])?.hasError('required')">
                  LGA is <strong>required</strong>
              </mat-error>
              </mat-form-field>

              <input title="Select media" #imgFileInput class="custom-file-input" 
              accept="image/*,video/*" multiple (change)="onFileSelected($event)"
                type="file">

            <div *ngIf="saleImagesPreview.length" class="images-preview">
                <div *ngFor="let image of saleImagesPreview; let imgIndex = index">
                    <mat-card>
                        <button type="button" class="del-img" (click)="removePreviewImage(imgIndex)" mat-icon-button aria-label="Delete image" color="warn">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <img [src]="image.dataUrl" mat-card-image alt="A supposed image of the item for sale">
                    </mat-card>
                </div>
            </div>

            <!-- TODO: should we include directions input? -->

            <div class="flex justify-between items-center pt-6">
              <app-progress-button type="submit" buttonText="Add" [loading]="addingPPA"></app-progress-button>
              
              <div class="flex gap-2">
                <button type="button" mat-stroked-button (click)="saveDraft()">Save as draft</button>
                <button type="button" mat-button (click)="close()">Close</button>
              </div>
            </div>
        </form>
    </section>
</div>